<div class="container-fluid h-100">
  <div class="styles-body h-100">
    <div class="panel panel-default body-space">
      <div class="panel-body content-body-pages">
        <div class="user-panel-default">
          <div class="row my-4 pb-1 ">
            <div class="col-md-6 col-12">
              <app-frontend-input [(value)]="title"
                                  [required]="true"
                                  [title]="'Title'"></app-frontend-input>
            </div>
            <div class="col-md-6 col-12">
              <app-frontend-input [(value)]="standardCode"
                                  [required]="true"
                                  [title]="'StandardCode'"></app-frontend-input>
            </div>
            <div class="col-md-6 col-12">
              <app-frontend-input [(value)]="price"
                                  [required]="true"
                                  [title]="'Price'"
                                  [type]="'number'"></app-frontend-input>
            </div>
            <div class="col-md-6 col-12">
              <app-frontend-input [(value)]="newPrice"
                                  [required]="false"
                                  [title]="'NewPrice'"
                                  [type]="'number'"></app-frontend-input>
            </div>
            <div class="col-md-6 col-12">
              <app-frontend-input [(value)]="maxCapacity"
                                  [required]="true"
                                  [title]="'MaxCapacity'"
                                  [type]="'number'"></app-frontend-input>
            </div>
            <div class="col-md-6 col-12">
              <app-frontend-select
                [(value)]="categoryId"
                [controller]="'categories'"
                [displayKey]="'Title,CategoryId'"
                [fieldName]="'CategoryId'"
                [method]="'get'"
                [microservice]="Constant.FOOD_SHOP"
                [protocolMethod]="'POST'"
                [required]="true"
                [searchOnKey]="'Title,CategoryId'"
                [selectedOptions]="[(serviceId && service?.Category) ? service.Category : []]"
                [title]="'Category'"
                [version]="'v1'"></app-frontend-select>
            </div>
            <!--            <div class="col-md-6 col-12">-->
            <!--              <app-frontend-select-->
            <!--                [(value)]="tagId"-->
            <!--                [controller]="'tags'"-->
            <!--                [displayKey]="'Title,TagId'"-->
            <!--                [fieldName]="'TagId'"-->
            <!--                [method]="'get'"-->
            <!--                [microservice]="Constant.FOOD_SHOP"-->
            <!--                [protocolMethod]="'POST'"-->
            <!--                [required]="false"-->
            <!--                [searchOnKey]="'Title,TagId'"-->
            <!--                [selectedOptions]="[serviceId ? service?.Tag : []]"-->
            <!--                [title]="'Tag'"-->
            <!--                [version]="'v1'"></app-frontend-select>-->
            <!--            </div>-->
            <div class="col-md-6 col-12">
              <app-frontend-input [(value)]="orderedCount"
                                  [required]="true"
                                  [title]="'OrderedCount'"
                                  [type]="'number'"></app-frontend-input>
            </div>
            <div class="col-md-6 col-12">
              <app-frontend-input [(value)]="startDate"
                                  [required]="false"
                                  [title]="'StartDate'"
                                  [type]="'time'"></app-frontend-input>
            </div>
            <div class="col-md-6 col-12">
              <app-frontend-input [(value)]="endDate"
                                  [required]="false"
                                  [title]="'EndDate'"
                                  [type]="'time'"></app-frontend-input>
            </div>
            <div class="col-md-6 col-12">
              <app-frontend-check-box [(value)]="isActive"
                                      [title]="'IsActive'"></app-frontend-check-box>
            </div>
            <div class="col-12">
              <app-frontend-text-area [(value)]="description"
                                      [required]="false"
                                      [title]="'Description'"></app-frontend-text-area>
            </div>
            <div class="col-12">
              <app-frontend-file-chooser [(files)]="imageFiles"
                                         [accept]="'png'"
                                         [isMultiple]="true"
                                         [title]="'Images'"></app-frontend-file-chooser>
            </div>
          </div>
        </div>
        <div class="dialog-footer">
          <mat-dialog-actions align="end"
                              class="py-0">
            <div class="col-12 d-flex align-items-center justify-content-end footer"
                 style="gap: 16px">
              <app-frontend-button (onSubmit)="onSubmitClicked()"
                                   [Image]="true"
                                   [class]="'card-green'"
                                   [disabled]="false"
                                   [src]="'icons/tick-square.svg'"
                                   [title]="'Submit'"
                                   [validationRequired]="true">
              </app-frontend-button>
              <app-frontend-button (click)="onCancelClicked()"
                                   [Image]="true"
                                   [class]="'card-yellow'"
                                   [disabled]="false"
                                   [src]="'icons/close-square.svg'"
                                   [title]="'Cancel'">
              </app-frontend-button>
            </div>
          </mat-dialog-actions>
        </div>
      </div>
    </div>
  </div>
</div>
